import { useTranslation } from 'react-i18next';
import { EditOutlined as EditOutlinedIcon } from '@mui/icons-material';

import {
  ActionButton,
  ActionIconButton,
  MainActionButton,
  type ActionButtonProps,
  type ActionIconButtonProps,
  type MainActionButtonProps,
} from '@/components/buttons';

export type EditMainActionButtonProps = MainActionButtonProps;

export const EditMainActionButton = (props: EditMainActionButtonProps) => {
  const { t } = useTranslation('actions');

  const { children = t('edit') } = props;

  return (
    <MainActionButton startIcon={<EditOutlinedIcon fontSize="small" />} {...props}>
      {children}
    </MainActionButton>
  );
};

export type EditActionButtonProps = ActionButtonProps;

export const EditActionButton = (props: EditActionButtonProps) => {
  const { t } = useTranslation('actions');

  const { children = t('edit') } = props;

  return (
    <ActionButton startIcon={<EditOutlinedIcon fontSize="small" />} {...props}>
      {children}
    </ActionButton>
  );
};

export type EditActionIconButtonProps = ActionIconButtonProps;

export const EditActionIconButton = (props: EditActionIconButtonProps) => {
  const { t } = useTranslation('actions');

  return (
    <ActionIconButton title={t('edit')} {...props}>
      <EditOutlinedIcon fontSize="medium" />
    </ActionIconButton>
  );
};
